import client from "../graphqlClient";
import {
  GET_USER_PERMISSIONS,
  GET_USERS,
  GET_USER_COUNTRY,
  GET_USER_INFO,
} from "./graphql";
import { getGraphqlResult } from "../../Utilities/Functions";

const loadPermissions = async () => {
  try {
    const response = await client.query({
      query: GET_USER_PERMISSIONS,
      fetchPolicy: "network-only",
    });
    const results = getGraphqlResult(response, "getUserPermissions");
    return results;
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getUsers = async () => {
  try {
    const response = await client.query({
      query: GET_USERS,
      fetchPolicy: "network-only",
    });
    const results = getGraphqlResult(response, "getUsers");
    return results;
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getUserCountry = async (userLocale) => {
  const response = await client.query({
    query: GET_USER_COUNTRY,
    fetchPolicy: "no-cache",
    variables: {
      userLocale,
    },
  });
  const results = await getGraphqlResult(response, "getUserCountry");
  return results;
};

const getUserInfo = async (userLocale) => {
  try {
    const response = await client.query({
      query: GET_USER_INFO,
      fetchPolicy: "network-only",
    });
    const results = getGraphqlResult(response, "getUserInfo");
    return results;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export { loadPermissions, getUsers, getUserCountry, getUserInfo };
